/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const DeviceMobileIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Device Mobile',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 20 20"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <circle cx="5" cy="8.00001" r=".625" fill="currentColor" />
    <path
      d="m8,14.00001h-3.75c-1.24023,0-2.25-1.00977-2.25-2.25v-7.5c0-1.24023,1.00977-2.25,2.25-2.25h11.5c1.24023,0,2.25,1.00977,2.25,2.25,0,.41406-.33594.75-.75.75s-.75-.33594-.75-.75c0-.41309-.33691-.75-.75-.75H4.25c-.41309,0-.75.33691-.75.75v7.5c0,.41309.33691.75.75.75h3.75c.41406,0,.75.33594.75.75s-.33594.75-.75.75Z"
      fill="currentColor"
    />
    <path
      d="m16.25,18.00001h-4.5c-.96484,0-1.75-.78516-1.75-1.75V7.75001c0-.96484.78516-1.75,1.75-1.75h4.5c.96484,0,1.75.78516,1.75,1.75v8.5c0,.96484-.78516,1.75-1.75,1.75Zm-4.5-10.5c-.1377,0-.25.1123-.25.25v8.5c0,.1377.1123.25.25.25h4.5c.1377,0,.25-.1123.25-.25V7.75001c0-.1377-.1123-.25-.25-.25h-4.5Z"
      fill="currentColor"
    />
    <circle cx="14" cy="15.00001" r=".625" fill="currentColor" />
  </svg>`;
};
